import React from 'react';
import {Button, Form, Input, notification} from "antd";
import {forgotPassword} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {useHistory} from "react-router-dom";

function ForgotPassword() {
    let history = useHistory();

    function onFinish(values) {
        forgotPassword(JSON.stringify(values)).then((response) => {
            if (response.data === "OK") {
                notification.success({
                    message: "Başarılı",
                    description: "Mail başarılı bir şekilde gönderildi. Lütfen mail kutunuzu kontrol ediniz",
                    onClose: () => {
                        history.push("/login");
                    }
                });
            }
        }).catch(error => {
            showAxiosError(error.response);
        })
    }

    function handleKeyPress(event) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }

    return (
        <div style={{
            marginTop: "250px",
            marginLeft: "auto",
            marginRight: "auto",
            width: "50%",
            padding: "10px"
        }}>
            <Form layout="vertical" className="sign-up-form" onFinish={onFinish}>
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {
                            type: "email",
                            required: true,
                            message: "Lütfen Emailinizi Giriniz.",
                        },
                    ]}
                >
                    <Input className="sign-up-form-input" name="email" size="large"/>
                </Form.Item>
                <Form.Item
                    label="TC Kimlik Numaranız"
                    name="tckn"
                    rules={[
                        {
                            required: true,
                            min: 11,
                            max: 11,
                            message: "Lütfen TC Kimlik Numaranızı Giriniz.",
                        },
                    ]}
                >
                    <Input onKeyPress={handleKeyPress} className="sign-up-form-input" name="tckn" size="large" maxLength={11}/>
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="sign-up-submit-btn d-flex align-center justify-center"
                        name="submit"
                    >
                        <p>Gönder</p>
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/page/forgotPassword/forgotPassword.js